export default __webpack_public_path__ + "static/media/flower_img_top_conversation.5c08fe5c.png";